<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Dati Identificativi</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-input
                          vid="code"
                          :name="beForm[rep].display.label"
                          :label="beForm[rep].display.label"
                          v-model="form[rep].display"
                          placeholder="Inserisci un codice"
                          :rules="{ required: true }"
                          maxlength="3"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          vid="title"
                          :name="beForm[rep].title.label"
                          label="Descrizione"
                          v-model="form[rep].title"
                          placeholder="Inserisci una descrizione"
                          :rules="{ required: true }"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          vid="sector_id"
                          :name="beForm[rep].sector_id.label"
                          :label="beForm[rep].sector_id.label"
                          v-model="form[rep].sector_id"
                          :options="sector_opt"
                          :taggable="false"
                          :multiple="false"
                          :closeOnSelect="true"
                          :rules="getRules('sector_id')"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          vid="info"
                          :name="beForm[rep].info.label"
                          :label="beForm[rep].info.label"
                          v-model="form[rep].info"
                          :rules="getRules('info')"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>

              <div class="mt-2" v-show="customInputs[rep].length">
                <div class="form-card-wrapper">
                  <b-card header-tag="header">
                    <template #header>
                      <b>Attributi personalizzati</b>
                    </template>
                    <b-card-text>
                      <custom-inputs
                        :customInputs="customInputs[rep]"
                        v-model="form[rep]"
                        :beForm="beForm[rep]"
                        :beRules="beRules[rep]"
                      />
                    </b-card-text>
                  </b-card>
                </div>
              </div>

              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
      <span
        :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
      >
        <b-button
          @click="handleSubmit(onSubmit)"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          :title="`${
            invalid
              ? 'Compila correttamente i campi per poter salvare'
              : 'Invia il form'
          }`"
        >
          Salva
        </b-button>
      </span>
                    <b-button
                      @click="resetForm()"
                      class="btn--transparent btn-reset"
                      type="button"
                      title="Pulisci tutti i campi e compila il form nuovamente"
                    >Reset
                    </b-button
                    >
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left
                      >
                      Torna indietro
                    </b-button
                    >
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>

      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import CustomInputs from "@/components/form/CustomInputs";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import FormMixin from "@/mixins/FormMixin";

export default {
  mixins: [FormMixin, ShortcutMixin],
  data() {
    return {
      repository: "treasury",
      id: this.$route.params.id,
      sector_opt: [],
      form: {
        treasury: {
          display: null,
          info: null,
          status_treasury: null,
          sector_id: null,
          title: null,
          is_sundry_expense: "N",
        },
      },
    };
  },
  components: {
    CustomInputs,
    BaseInput,
    BaseSelect,
  },
  methods: {
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "profile-agency-treasuries-create":
            this.$router.push({
              name: "agency_treasuries.create",
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior."
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    onSubmit() {
      this.isLoading = true;
      this.store(this.repository)
        .then(() => {
          this.$store.dispatch("auth/treasuries");
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Cassa di Agenzia Creata`,
          });
          this.shortcut(
            "module.PROF.CAGG",
            null,
            "#AgencyTreasuries",
            "filterAgencyTreasury"
          );
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.isLoading = true;
    this.fetchCreateForm(this.repository).then(() => {
      this.sector_opt = this.$store.state.auth.sectors
        .filter((sector) => sector.is_agency.value === "Y")
        .map((el) => {
          return {
            value: el.id,
            text: el.title,
          };
        });
      this.isLoading = false;
    });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
